import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const PrinterSettings = lazyWithRetry(() => import(/* webpackChunkName: "printer-settings" */'../../component/Settings/PrinterSettings'))

const PrinterSettingsPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<PrinterSettings />
		</Suspense>
	)
})

PrinterSettingsPage.displayName = 'PrinterSettingsPage'
export default PrinterSettingsPage
